import { Box, Editable, EditablePreview, EditableTextarea, Text } from '@chakra-ui/react';
import { DragHandleIcon } from '@chakra-ui/icons';
import { ReactSortable } from 'react-sortablejs';
import React from 'react';
import { composeBullet, getDivider, getEndDate, getStartDate } from '../utils';
import { RiCircleFill } from 'react-icons/ri';
import { getUsefulVars, setUcfirst } from '../../../handlers/helpers';
import { updateBulletData } from '../../../formElements/Bullets/utils';
import { freeFormEdit } from '../utils';
import EditButton from '../components/EditButton';

const PreviewWork = ({ items, props }) => {
  const sectionName = 'professional-experience';
  const buttonLabel = 'Enhance';
  const uv = getUsefulVars(props);
  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const existingBulletNotice = ''; //Finalize your bullets in the bullet bank.
  return (
    <Box className="contentBox">
      {Object.values(items.map((item, sectionIndex) => {
            const city = item.city !== undefined ? item.city : '';
            const state = item.state !== undefined ? item.state : '';
            const address = item.location === 'inperson' ? city + getDivider(city, state, ', ') + state : 'Remote';
            return (
              <Box className="subSections">
                {/*Text is necessary above to make _last work*/}
                <Box className="subSectionsInterior">
                  <Box className="subSection subSectionPE">
                    <Box className="name">{item.company_name}</Box>
                    <Box marginTop='1px' className="jobTitle">{item.job_title}</Box>
                  </Box>
                  <Box minWidth='20%'>
                    <Box className="address">
                      <Box className="alignRight">{setUcfirst(address)}</Box>
                    </Box>
                    <Box className="dates" minWidth='20%'>
                      <Text className="startDate">{getStartDate(item)}</Text>
                      <Text className="endDate">{getEndDate(item)}</Text>
                    </Box>
                  </Box>
                </Box>
                <Box>

                  <Box>

                    {item['existing'] !== undefined && item['bulletsb'] === undefined && (

                      <Box>
                        {existingBulletNotice}
                        {Object.values(item['existing']).map((bullet) =>  {

                          const compositedBullet = composeBullet(bullet);
                          return (
                            <Box className="bulletsWrap">
                              <Text className="bulletIcon"><RiCircleFill /></Text>
                              <Text className="bulletText">{compositedBullet}</Text>
                            </Box>
                          );
                        })
                        }


                      </Box>
                    )
                    }

                    {item['bulletsb'] !== undefined && (
                      <ReactSortable
                        list={item['bulletsb']}
                        setList={(newState) => {
                          const resumes = uv.stateProps.dataToSave.saved.resumes;
                          resumes[uv.resumeIndex]['professional-experience'][sectionIndex]['bulletsb'] = newState;
                         // jobSeekerData[sectionIndex]['bulletsb'] = newState;
                          item['bulletsb'] = newState;
                          updateBulletData({ selectedBullets: newState }, uv.stateProps);
                        }}
                        handle={".drag-handle"}
                        filter={".chakra-editable__input, .chakra-editable__textarea, [contenteditable]"}
                        preventOnFilter={true}
                      >
                        {Object.values(item['bulletsb']).map((bullet) => {
                          const compositedBullet = composeBullet(bullet);
                          return (
                            <Editable
                              key={bullet.key ? bullet.key : compositedBullet}
                              className='editableWork'
                              autoResize
                              defaultValue={compositedBullet}
                            >
                              <Text className="bulletIcon">
                                <DragHandleIcon
                                  className="drag-handle"
                                  sx={{
                                    color: 'ORANGE_TEXT',
                                    alignSelf: 'center',
                                    cursor: 'grab',
                                    fontSize: '2em',
                                  }}
                                />
                              </Text>
                              <EditablePreview />
                              <EditableTextarea onBlur={(e) => freeFormEdit(e, bullet, sectionIndex, uv, item)} />
                            </Editable>
                          );
                        })}
                      </ReactSortable>
                    )}
                    <EditButton props={props} buttonLabel={buttonLabel} target={sectionName} sectionIndex={sectionIndex} />
                  </Box>
                </Box>
              </Box>

            );
          },
        ),
      )
      }

    </Box>
  );
};
export default PreviewWork;
